
import createIcon from "./createIcon";

export const LetterIcon = createIcon('Letter', (props) => {
  return (
    <svg {...props}>
      <defs>
        <linearGradient x1="8.000000" y1="1.454590" x2="8.000000" y2="14.545499" id="paint_linear_497_2172_0" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FDE0B0" />
          <stop offset="1.000000" stopColor="#E3A852" />
        </linearGradient>
      </defs>
      <rect id="切图-入口-信" width="16.000000" height="16.000000" fill="#FFFFFF" fillOpacity="0" />
      <path id="path" d="M16 13.63C16 13.75 15.97 13.86 15.93 13.96L9.96 8L15.93 2.03C15.97 2.13 16 2.24 16 2.36L16 13.63ZM9.45 8.51L8.64 9.32C8.6 9.36 8.55 9.4 8.5 9.43C8.45 9.47 8.4 9.5 8.34 9.52C8.29 9.54 8.23 9.56 8.17 9.57C8.11 9.58 8.05 9.59 8 9.59C7.94 9.59 7.88 9.58 7.82 9.57C7.76 9.56 7.7 9.54 7.65 9.52C7.59 9.5 7.54 9.47 7.49 9.43C7.44 9.4 7.39 9.36 7.35 9.32L6.54 8.51L0.57 14.48C0.68 14.52 0.79 14.54 0.9 14.54L15.09 14.54C15.2 14.54 15.31 14.52 15.42 14.48L9.45 8.51ZM6.8 7.74L7.87 8.81C7.88 8.82 7.9 8.84 7.93 8.85C7.95 8.85 7.97 8.86 8 8.86C8.02 8.86 8.04 8.85 8.06 8.85C8.09 8.84 8.11 8.82 8.12 8.81L9.19 7.74L15.42 1.51C15.31 1.47 15.2 1.45 15.09 1.45L0.9 1.45C0.79 1.45 0.68 1.47 0.57 1.51L6.8 7.74ZM0.06 2.03C0.02 2.13 0 2.24 0 2.36L0 13.63C0 13.75 0.02 13.86 0.06 13.96L6.03 8L0.06 2.03Z" fill="url(#paint_linear_497_2172_0)" fillOpacity="1.000000" fillRule="nonzero" />
    </svg >
  )
});
